import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'
import { TrainingAirportQualificationsRouter } from './airport-qualifications/_router'
import { TrainingDocumentVerificationRouter } from './document-verification/_router'
import { TrainingExpiriesRouter } from './expiries/_router'
import { TrainingPilotQualificationsRouter } from './pilot-qualifications/_router'
import { TrainingRatingsRouter } from './ratings/_router'
import { TrainingScandlearnRouter } from './scandlearn/_router'
import { TrainingSessionsRouter } from './sessions/_router'
import { TrainingSkylegsArchiveRouter } from './skylegs-archive/_router'
import { TrainingUntypedQualificationsRouter } from './untyped-qualifications/_router'
import { TrainingUserRecordsRouter } from './user-records/_router'

const Index = lazy(() => import('./Index'))

export const TrainingRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--training']}>
    <Route index element={<Index />} />
    <Route path='expiries/*' element={<TrainingExpiriesRouter />} />
    <Route path='airport-qualifications/*' element={<TrainingAirportQualificationsRouter />} />
    <Route path='pilot-qualifications/*' element={<TrainingPilotQualificationsRouter />} />
    <Route path='user-records/*' element={<TrainingUserRecordsRouter />} />
    <Route path='document-verification/*' element={<TrainingDocumentVerificationRouter />} />
    <Route path='ratings/*' element={<TrainingRatingsRouter />} />
    <Route path='untyped-qualifications/*' element={<TrainingUntypedQualificationsRouter />} />
    <Route path='sessions/*' element={<TrainingSessionsRouter />} />
    <Route path='skylegs-archive/*' element={<TrainingSkylegsArchiveRouter />} />
    <Route path='scandlearn/*' element={<TrainingScandlearnRouter />} />
  </SubRouter>
))
